import { baseURL, COUNTRY_CCA3, ENDPOINTS, placeholderImage } from "config/constants";
import { BoxModel, CameraModel, CCA3, SiteModel } from "types";
import { isURL } from "./validators";

export const getDates = (
  startDate: Date | string | number,
  endDate: Date | string | number,
  valuesCount?: number,
  jump = 1,
  multiple = "days"
) => {
  const dates = new Array<Date>();
  let currentDate = new Date(startDate);
  const stopDate = new Date(endDate);
  if (valuesCount) {
    const diff = (stopDate.valueOf() - currentDate.valueOf()) / valuesCount;
    while (currentDate <= stopDate) {
      dates.push(currentDate);
      currentDate = new Date(currentDate.valueOf() + diff);
    }
  } else {
    const final_multiple =
      multiple === "hours"
        ? 1000 * 60 * 60
        : multiple === "days"
        ? 1000 * 60 * 60 * 24
        : multiple === "weeks"
        ? 1000 * 60 * 60 * 24 * 7
        : 1000 * 60;

    while (currentDate <= stopDate) {
      dates.push(currentDate);
      currentDate = new Date(currentDate.valueOf() + jump * final_multiple);
    }
  }

  return dates;
};

export const getImagePath = (path?: string) => {
  return path ? (isURL(path) ? path : isURL(baseURL + path) ? baseURL + path : path) : placeholderImage;
};

export const getSignedUrl = (path?: string) => {
  if (!path) return placeholderImage;
  const url = isURL(path) ? path : isURL(baseURL + path) ? baseURL + path : path;
  if (!url || !isURL(url)) return getImagePath(path);
  if (url.includes("storage.googleapis.com/")) {
    // Always proxy via /signed with the canonical object URL. Do not use short-lived
    // signatures embedded in API JSON — they expire while the page is still open.
    const canonical = url.split("?")[0];
    const params = new URLSearchParams();
    params.append("filePath", canonical);
    return ENDPOINTS.signed + "?" + params.toString();
  }
  return getImagePath(path);
};

export const minutesFromTimeString = (time: string) => {
  const split = time.split(":");
  let h = Number.parseInt(split[0]) || 0;
  let m = Number.parseInt(split[1]) || 0;

  return h * 60 + m;
};

export const getCountryName = (cca3: CCA3) => {
  const country = COUNTRY_CCA3.find((item) => item.value === cca3);
  return country?.label || "N/A";
};

export const getJoinStrings = (
  strings: string[],
  options: Intl.ListFormatOptions = { type: "disjunction" },
  locales?: string | string[]
) => {
  const f = new Intl.ListFormat(locales, options);
  return f.format(strings);
};

export const getSiteLabel = (site?: null | SiteModel) => {
  if (!site?.siteId) {
    return "Deleted Site";
  }
  return `Site #${site.siteId} - ${site.name}`;
};

export const getBoxLabel = (box?: null | BoxModel) => {
  if (!box?.boxId) {
    return "Deleted Box";
  }
  return `Box #${box.boxId} - ${box.name ? box.name : box.deviceId}`;
};

export const getCameraLabel = (value?: null | CameraModel) => {
  if (!value?.cameraId) {
    return "Deleted Camera";
  }
  return `#${value.cameraId} - ${value.name || value.rtspHost || ""}`;
};
